export default "__VITE_ASSET__DHlWAIUE__"